import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import theme from '../../styles/theme';

const ToastBody = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  overflow: hidden;
  .toast-body__text {
    margin-left: ${theme.spacing['spacing-3']};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing['spacing-1']};
    min-width: 0;
    flex: 1;
    overflow: hidden;
    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
  }
`;

const IconCloseWrapper = styled.div`
  align-self: center;
  padding-left: ${theme.spacing['spacing-3']};
`;

const Toast = styled(ToastContainer)`
  .Toastify__toast {
    box-shadow: ${theme.elevations[`elevation-1`]};
  }

  .Toastify__toast-body {
    width: 410px;
    display: flex;
  }

  .Toastify__toast-icon {
    display: none;
  }

  &.Toast__toast-body--md-full {
    width: 100%;
  }
  &.Toastify__toast-container {
    z-index: 9999;
    position: fixed;
  }
  .Toastify__toast {
    width: auto;
    max-width: 410px;
    display: flex;
    justify-content: space-between;
    border-radius: ${theme.borderRadius['border-radius-4']};
    margin: ${theme.spacing['spacing-4']};
    padding: ${theme.spacing['spacing-0']} ${theme.spacing['spacing-4']};
    height: 80px;
    min-height: 80px;
    align-items: center;
  }

  &.Toastify__toast-container--top-right {
    top: 0;
    right: 0;
  }

  &.Toastify__toast-container--top-left {
    top: 0;
    left: 0;
  }
  &.Toastify__toast-container--top-center {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &.Toastify__toast-container--bottom-left {
    bottom: 0;
    left: 0;
  }
  &.Toastify__toast-container--bottom-center {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  &.Toastify__toast-container--bottom-right {
    bottom: 0;
    right: 0;
  }
  .Toastify__toast--success {
    background: ${theme.colors.success.bg.stronger};
  }
  .Toastify__toast--error {
    background: ${theme.colors.danger.bg.regular};
  }
  .Toastify__toast--info {
    background: ${theme.colors.info.bg.regular};
  }
  .Toastify__toast--warning {
    background: ${theme.colors.warning.bg.regular};
  }
  @keyframes Toastify__fadeIn {
    from {
      opacity: ${theme.opacities['opacity-4']};
    }
    to {
      opacity: ${theme.opacities['opacity-1']};
    }
  }
  @keyframes Toastify__fadeOut {
    from {
      opacity: ${theme.opacities['opacity-1']};
    }
    to {
      opacity: ${theme.opacities['opacity-4']};
    }
  }
  .Toastify__fade-enter {
    animation-name: Toastify__fadeIn;
  }

  .Toastify__fade-exit {
    animation-name: Toastify__fadeOut;
  }
  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
`;

export { ToastBody, Toast, IconCloseWrapper };
